<template>
  <section class="play-button-text-container">
    <span :class="videoStatus === 1 ? 'play-button-text-disabled' : ''" @click="handleClick">
      <span>{{ $t(videoStatus === 0 || videoStatus === 1 ? 'video-play' : 'video-replay') }}</span>
      <svg width="14" height="14" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.5 11C8.53757 11 11 8.53757 11 5.5C11 2.46243 8.53757 0 5.5 0C2.46243 0 0 2.46243 0 5.5C0 8.53757 2.46243 11 5.5 11ZM7.1003 5.84611C7.36697 5.69215 7.36697 5.30725 7.1003 5.15329L5.0003 3.94085C4.73363 3.78689 4.4003 3.97934 4.4003 4.28726V6.71213C4.4003 7.02005 4.73363 7.2125 5.0003 7.05854L7.1003 5.84611Z"
          fill="currentColor"
        />
      </svg>
    </span>
  </section>
</template>
<script>
export default {
  props: {
    targetVideo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 0： 播放
      // 1:  播放中
      // 2:  重新播放
      videoStatus: 0
    };
  },
  methods: {
    init() {
      this.$nextTick(() => {
        if (!this.targetVideo) return;
        this.video = document.querySelector(this.targetVideo);
        this.video.addEventListener('ended', () => {
          this.videoStatus = 2;
        });
        this.video.addEventListener('pause', () => {
          this.videoStatus = 0;
        });
        this.video.addEventListener('playing', () => {
          this.videoStatus = 1;
        });
      });
    },
    handleClick() {
      if (this.videoStatus === 0 || this.videoStatus === 2) {
        if (this.video) {
          if (this.video.currentTime === this.video.duration) {
            this.video.currentTime = 0;
          }
          this.video.play();
        }
      } else {
        // this.video.pause();
      }
    }
  }
};
</script>
<style lang="scss">
.play-button-text-container {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -38px;
  margin: auto;
  padding-top: 12px;
  padding-bottom: 12px;
  font-size: 14px;
  line-height: 14px;
  text-align: center;
  color: black;
  font-variation-settings: 'wght' 750;
  svg {
    padding-left: 4px;
    vertical-align: -2px;
  }
  .play-button-text-disabled {
    color: rgba(0, 0, 0, 0.3);
  }
}
html:not([lang|='zh-CN']) {
  .play-button-text-container svg {
    vertical-align: middle;
  }
}
</style>
